export default __webpack_public_path__ + "static/media/minus-sign.960b00f9.svg";